export default {
    'please-select-account-filter': 'Please select account filter',
    'please-select-item-filter': 'Please select item filter',
    'please-select-a-filter': 'Please select a filter',
    'total-quantities': 'Total quantities'
}